module.exports = __webpack_public_path__ + "static/media/foex.gif.d41d8cd9.crdownload";